module.exports = __webpack_public_path__ + "static/img/newPrice_3.00410cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newPrice_3.jpg
// module id = 1unk
// module chunks = 1